import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offered',
  templateUrl: './offered.component.html',
  styleUrls: ['./offered.component.scss']
})
export class OfferedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
